import $ from "jquery";

/**
 * A FilterControl plugs into the calendar core's filter pipeline.
 *
 * {
 *   key,               // unique id; also the URL param key unless paramKey is set
 *   paramKey,          // optional; false => never serialized to a URL param
 *   predicate,         // optional (event) => bool; filterEvents ANDs all predicates
 *   serialize,         // optional () => string|null; control owns "omit if all selected"
 *   serializeForIcal,  // optional; false => excluded from the iCal URL
 *   getState,          // optional () => any; readable via controller.getFilterState(key)
 *   init,              // optional (ctx) => void; ctx.controller, ctx.triggerChange()
 * }
 */

/**
 * Built-in calendar multi-select control (#calendar-select, a Select2 widget).
 *
 * NOTE: this control intentionally has no event predicate. Calendar visibility
 * reaches events only through a project's category->calendar mapping (see the
 * category control in sfc.js); here the calendar selection is purely a state
 * provider + URL param. jQuery is required because Select2 fires jQuery events.
 */
export function createCalendarSelectControl(el, opts) {
  opts = opts || {};
  var selectId = opts.selectId || "calendar-select";
  var calendarSelect = document.getElementById(selectId);

  var activeCalendars = new Set();
  var allCalendarIds = new Set();

  if (calendarSelect) {
    Array.from(calendarSelect.options).forEach(function (option) {
      allCalendarIds.add(option.value);
    });
    Array.from(calendarSelect.selectedOptions).forEach(function (option) {
      activeCalendars.add(option.value);
    });
  }

  return {
    key: "calendars",
    getState: function () {
      return { active: activeCalendars, all: allCalendarIds };
    },
    serialize: function () {
      if (activeCalendars.size === allCalendarIds.size) return null;
      var ids = Array.from(activeCalendars).sort().join(",");
      return ids || null;
    },
    init: function (ctx) {
      if (!calendarSelect) return;
      // Select2 fires jQuery change events
      $(calendarSelect).on("change", function () {
        activeCalendars.clear();
        Array.from(calendarSelect.selectedOptions).forEach(function (option) {
          activeCalendars.add(option.value);
        });
        ctx.triggerChange("calendars");
      });
    },
  };
}
